import VideoListItem from "core/components/VideoListItem";
import { _t } from "core/language";
import { getYouTubeThumbnail } from "core/utils/helper";
import React, { useEffect, useState } from "react";
import { useRandomRecipe } from "../hooks";
import { RandomRecipesData } from "../type";
import MainNodata from "./NodataComponent";
import SectionSkeleton from "./SectionSkeleton";
import IconSectionVideo from "./icon/IconSectionVideoNew";
// import MoreIcon from "../assets/icon/more.svg";
// import IconTitle from "../assets/images/icon_section_video.svg";

const VideoSection = ({refresh}:any) => {
  const [paramsRandomRecipe,setParamsRandomRecipe] = useState({
    refresh: Date.now(),
  });

  useEffect(() => {
    setParamsRandomRecipe({
      refresh: refresh,
    })
  }, [refresh]);

  const [randomRecipes, loading] = useRandomRecipe(paramsRandomRecipe);

  const hasData = randomRecipes?.length > 0;
  return (
    <section className="mt-2 pt-[20px] pb-[30px] w-full bg-white mb-[-10px]">
      <div className="pl-[16px]">
        <p className="z-10 text-[#777777] text-[12px] font-normal mb-[2px]">
          {_t("main.video_section_title")}
        </p>
        <h1 className="text-[16px] font-bold text-[#111111] flex items-center">
          {/* <img className="mr-1" src={IconTitle} alt="" /> */}
          <div className="">
            <IconSectionVideo />
          </div>
          {_t("main.video_section_description")}
        </h1>
        {/* <img className="mr-2" src={MoreIcon} alt="" /> */}
      </div>
      <div className="flex flex-col items-start overflow-x-scroll no-scrollbar px-4">
        <div className="flex mt-3.5 gap-2">
          {(loading && !hasData) && <SectionSkeleton width={320} height={184} />}
          {(randomRecipes || []).map((video: RandomRecipesData, index: number) => (
            <VideoListItem
              key={index}
              className={`w-[280px]`}
              classNameImg={`!h-[157px]`}
              image={video?.thumbnail || getYouTubeThumbnail(video?.video_id)}
              dataItem={video}
              name={video.name}
              showIcon
              type={1}
              videoId={video.video_id}
              id={video.video_id?.toString()}
            />
          ))}
        </div>
        <MainNodata loading={loading} data={randomRecipes} text={_t("main.no_data")} />
      </div>
    </section>
  );
};

export default VideoSection;
